import { useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import profileImage from '../../assets/profile-picture.jpg';
import { groupedSkills } from '../../data/skills';

const Home = () => {
    const navigate = useNavigate();
    const handleBtnClick = () => navigate('/caseStudies');

    useEffect(() => {
        const container = document.getElementById('skills-scroll');
        let isDown = false;
        let startX
        let scrollLeft

        if (!container) return;

        const mouseDown = (e) => {
            isDown = true;
            container.classList.add('dragging');
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        };

        const touchStart = (e) => {
            isDown = true;
            container.classList.add('dragging');
            startX = e.touches[0].pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        }

        const mouseLeave = () => {
            isDown = false;
            container.classList.remove('dragging');
        };

        const mouseUp = () => {
            isDown = false;
            container.classList.remove('dragging');
        };

        const touchEnd = () => {
            isDown = false;
            container.classList.remove('dragging');
        }

        const mouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2;
            container.scrollLeft = scrollLeft - walk;
        };

        const touchMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.touches[0].pageX - container.offsetLeft;
            const walk = (x - startX) * 2;
            container.scrollLeft = scrollLeft - walk;
        }

        container.addEventListener('mousedown', mouseDown);
        container.addEventListener('mouseleave', mouseLeave);
        container.addEventListener('mouseup', mouseUp);
        container.addEventListener('mousemove', mouseMove);
        container.addEventListener('touchstart', touchStart, { passive: false });
        container.addEventListener('touchmove', touchMove, { passive: false });
        container.addEventListener('touchend', touchEnd);

        return () => {
            container.removeEventListener('mousedown', mouseDown);
            container.removeEventListener('mouseleave', mouseLeave);
            container.removeEventListener('mouseup', mouseUp);
            container.removeEventListener('mousemove', mouseMove);
            container.removeEventListener('touchstart', touchStart, { passive: false });
            container.removeEventListener('touchmove', touchMove, { passive: false });
            container.removeEventListener('touchend', touchEnd);
        };
    }, []);

    const scrollByAmount = (amount) => {
        const container = document.getElementById('skills-scroll');
        if (container) {
            container.scrollBy({ left: amount, behavior: 'smooth' });
        }
    };

    return (
        <main className="homepage-section py-5 animate-fade-in">
            <Container>
                <header className="d-flex flex-column flex-md-row align-items-center gap-4 mb-5">
                    <img
                        src={profileImage}
                        alt="Jerry Forsberg"
                        className="hero-img"
                    />
                    <div className="terminal-shell">
                        <div className="terminal-bar">
                            <span className="terminal-dot red" />
                            <span className="terminal-dot yellow" />
                            <span className="terminal-dot green" />
                            <span className="terminal-title">~/portfolio</span>
                        </div>
                        <div className="terminal-body">
                            <h1 className="typewriter" aria-label="Jerry Forsberg">Jerry Forsberg</h1>
                            <p className="terminal-line">
                                <span className="prompt-symbol">$</span>
                                <span> Full-stack software developer experienced in creating responsive, scalable applications. Interested in developing and sharpening skills, solving problems, and contributing to the success of projects. Constructive communicator who enjoys cross-functional collaboration.</span>
                            </p>
                            <div className="terminal-actions d-flex flex-wrap gap-2 mt-3">
                                <Button onClick={handleBtnClick} variant="primary">View Case Studies</Button>
                                <Button variant="outline-light" href="/Jerry_Forsberg_CS.pdf" target="_blank">Download Resume</Button>
                                <Button variant="outline-light" href="https://github.com/JerryForsberg" target="_blank">
                                    <FaGithub className="me-2" /> GitHub
                                </Button>
                                <Button variant="outline-light" href="https://www.linkedin.com/in/jerry-forsberg/" target="_blank">
                                    <FaLinkedin className="me-2" /> LinkedIn
                                </Button>
                            </div>
                        </div>
                    </div>
                </header>

                <section className="skills-section mb-5 position-relative">
                    <h2 className="h4 mb-4">Core Skills</h2>
                    <div className="skills-scroll-wrapper d-flex align-items-center">
                        <button className="scroll-arrow left" onClick={() => scrollByAmount(-400)}>‹</button>

                        <div className="skills-scroll-container flex-grow-1" id="skills-scroll">
                            {groupedSkills.flatMap(group => group.skills).map(({ name, icon, color }) => (
                                <div key={name} className="skill-card text-center">
                                    <div className="icon" style={{ color }}>{icon}</div>
                                    <small>{name}</small>
                                </div>
                            ))}
                        </div>

                        <button className="scroll-arrow right" onClick={() => scrollByAmount(400)}>›</button>
                    </div>
                </section>

                <section className="text-center">
                    <h2 className="h4 mb-3">Explore My Work</h2>
                    <p className="mb-4">
                        I've contributed to a wide range of large scale production projects. Check out the case studies to see the tech stacks and additional details.
                    </p>
                    <Button variant="primary" onClick={handleBtnClick} size="lg">
                        View Case Studies
                    </Button>
                </section>
            </Container>
        </main>
    );
};

export default Home;
